// Token Debugger - Essential debugging tools for token refresh
import { tokenManager } from './tokenManager';
import { tokenRefreshManager } from './tokenRefreshManager';

export const tokenDebugger = {
    // Get current token status
    getStatus: () => {
        const token = tokenManager.getAccessToken();
        const user = tokenManager.getUser();
        const timeUntilExpiry = tokenManager.getTimeUntilExpiry();
        const isExpired = tokenManager.isTokenExpired();
        const isAuthenticated = tokenManager.isAuthenticated();

        const status = {
            hasToken: !!token,
            hasUser: !!user,
            isAuthenticated: isAuthenticated,
            timeUntilExpiry: {
                minutes: Math.floor(timeUntilExpiry / 1000 / 60),
                seconds: Math.floor((timeUntilExpiry % (60 * 1000)) / 1000)
            },
            isExpired,
            refreshMode: 'Reactive (401 errors only)',
            user: user ? { id: user.id, role: user.role, email: user.email } : null
        };

        console.table(status);
        return status;
    },

    // Test manual token refresh
    testRefresh: async () => {
        console.log('🧪 Testing manual token refresh...');
        try {
            await tokenRefreshManager.refreshTokenSilently();
            console.log('✅ Manual refresh successful!');
            return true;
        } catch (error) {
            console.error('❌ Manual refresh failed:', error.message);
            return false;
        }
    },

    // Test API call with reactive refresh
    testApiCall: async () => {
        console.log('🧪 Testing API call...');
        try {
            const axiosInstance = (await import('./axiosInstance')).default;
            const response = await axiosInstance.get('/users/profile');
            console.log('✅ API call successful!');
            return response.data;
        } catch (error) {
            console.error('❌ API call failed:', error.message);
            return null;
        }
    },

    // Test expired token flow
    testExpiredTokenFlow: async () => {
        console.log('🧪 Testing expired token flow...');
        
        // Set expired token
        const expiredToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InRlc3QiLCJleHAiOjEwMH0.invalid';
        localStorage.setItem('access_token', expiredToken);
        localStorage.setItem('token_timestamp', (Date.now() - 20 * 60 * 1000).toString());
        
        console.log('⚠️ Set expired token - API call should trigger 401 and refresh');
        return await tokenDebugger.testApiCall();
    }
};

// Auto-expose to window for debugging
if (typeof window !== 'undefined') {
    window.tokenDebugger = tokenDebugger;
    console.log('🔧 Token debugger available as window.tokenDebugger');
} 